import { cva } from 'class-variance-authority';

export const editableSelectVariants = cva(
  'flex h-10 w-full items-center justify-between rounded-md px-3 py-2 text-base transition-colors md:text-sm',
  {
    variants: {
      mode: {
        view: 'cursor-pointer bg-gray-50 border border-gray-300 hover:bg-gray-100',
        edit: 'bg-transparent border border-input ring-2 ring-ring-muted ring-offset-2',
      },
      disabled: {
        true: 'cursor-not-allowed opacity-50',
        false: '',
      },
    },
    defaultVariants: {
      mode: 'view',
      disabled: false,
    },
  },
);

export const editableSelectIconVariants = cva(
  'flex-shrink-0 transition-colors',
  {
    variants: {
      mode: {
        view: 'text-gray-500 hover:text-gray-700',
        edit: 'text-primary',
      },
      disabled: {
        true: 'opacity-50',
        false: '',
      },
    },
    defaultVariants: {
      mode: 'view',
      disabled: false,
    },
  },
);
